module.exports = __webpack_public_path__ + "static/media/home-shape.45b4533f.png";